import PageTitle from "../../components/PageTitle";
import Tx from "../../components/Tx";
import {api} from "../../maps/data.js";
import Table from '../../components/Table';
import {useEffect, useState} from "react";
import {sensorsI18nTypeMap} from "../../maps/sensorsI18nTypeMap";
import {_} from "../../domain/languageSlice";
import Btn from "../../components/Btn";
import Icn from '../../components/Icn';
import {colors} from '../../maps/colors';

import {useSnackbar} from 'notistack';
import SensorGrid from "../../components/sensorGrid/SensorGrid";
import useZibi from "../../zibi/UseZibi";


export default function SensorsPage(props) {

    const {enqueueSnackbar} = useSnackbar();

    const {
        distributorShowInstallerSensors,
        installer,
        installerSelectSensor,
        filterByTypes,
        showThisEdgeSensorsUnrelatedToField,
        edgeId,
        filterOutSensorIds = []
    } = props;

    const [sensors, set_sensors] = useZibi('sensors');

    const role = zibi.user.role[0];

    const getSensors = async () => {
        const cfg = {type: 'getSensors', data: {filterOutSensorIds}};

        if (distributorShowInstallerSensors) {
            cfg.data.installerId = installer._id;
        }

        if (filterByTypes?.length) {
            cfg.data.types = filterByTypes;
        }

        if (showThisEdgeSensorsUnrelatedToField) {
            cfg.data.edgeId = edgeId;
            cfg.data.showThisEdgeSensorsUnrelatedToField = true;
        }

        const sensors_res = await api(cfg);

        const temp = {};
        for (let i = 0; i < sensors_res.length; i++) {
            const sensorsRe = sensors_res[i];
            temp[sensorsRe._id] = {...sensorsRe, translatedType: _(sensorsI18nTypeMap[sensorsRe.type])};
        }
        set_sensors(temp);
    };

    const distributorAddShelf = async () => {
        await api({type: 'distributorAddShelf'});
        await getSensors();
    };

    const distributorAddStep = async () => {
        await api({type: 'distributorAddStep'});
        await getSensors();
    };

    const distributorAddShelfToInstaller = async () => {
        await api({type: 'distributorAddShelfToInstaller', data: {installerId: installer._id}});
        await getSensors();
    };

    const distributorAddStepToInstaller = async () => {
        await api({type: 'distributorAddStepToInstaller', data: {installerId: installer._id}});
        await getSensors();
    };

    const onUpdate = (e) => {
        enqueueSnackbar(e.detail.msg, {variant: 'success'});
        getSensors();
    };

    useEffect(() => {
        getSensors();
        window.addEventListener('socket.manufacture', onUpdate);

        return () => {
            window.removeEventListener('socket.manufacture', onUpdate);
        };

    }, []);

    let headers = [
        {label: <Tx>sensor.table.type</Tx>, field: 'translatedType'},
        {label: <Tx>sensor.table.mac</Tx>, field: 'mac'},
        {label: <Tx>sensor.table.shortId</Tx>, field: 'boardId'}
    ];

    let label = '';
    let actions = [];

    switch (role) {
        case 'SUPER_ADMIN':
            headers.push({label: <Tx>sensor.table.distributorName</Tx>, field: 'distributorName'});
            break;
        case 'DISTRIBUTOR_ADMIN':
            if (distributorShowInstallerSensors) {
                label = installer.name;
            } else {
                headers.push({label: <Tx>sensor.table.installerName</Tx>, field: 'installerName'});
            }
            break;
        case 'MANUFACTURER':
            headers.push({label: <Tx>sensor.table.distributorName</Tx>, field: 'distributorName'});
            headers.push({label: <Tx>sensor.table.installerName</Tx>, field: 'installerName'});
            break;
        case 'INSTALLER_ADMIN':
            if (installerSelectSensor) {
                actions = [
                    {
                        icon: 'add',
                        action: item => {
                            props.onSelect(item);
                        }
                    }
                ];
            }

    }

    const isTable = role !== 'MANUFACTURER';

    return (
        <div style={{height:'100%', overflowY: 'scroll', padding: 20}}>
            <PageTitle>
                <div style={{position: 'relative'}}>

                    <Icn>sensor</Icn> <Tx>page.sensors.title</Tx>
                    {
                        label && <div style={{color: colors.GRAY1, fontSize: 14}}>[{label}]</div>
                    }
                    {
                        ['DISTRIBUTOR_ADMIN'].includes(role) && !distributorShowInstallerSensors &&
                        <div style={{position: 'absolute', right: 10, top: 0}}>
                            <Btn onClick={distributorAddShelf} customtheme="normal"
                                 startIcon="add"><Tx>sensor.add.shelf</Tx></Btn>
                            <Btn onClick={distributorAddStep} customtheme="normal" startIcon="add"
                                 style={{marginLeft: 10}}><Tx>sensor.add.step</Tx></Btn>
                        </div>
                    }
                    {
                        ['DISTRIBUTOR_ADMIN'].includes(role) && !!distributorShowInstallerSensors &&
                        <div style={{position: 'absolute', right: 10, top: 0}}>
                            <Btn onClick={distributorAddShelfToInstaller} customtheme="normal"
                                 startIcon="add"><Tx>sensor.add.shelf</Tx></Btn>
                            <Btn onClick={distributorAddStepToInstaller} customtheme="normal" startIcon="add"
                                 style={{marginLeft: 10}}><Tx>sensor.add.step</Tx></Btn>
                        </div>
                    }
                </div>
            </PageTitle>
            {isTable && (
                <Table data={Object.values(sensors)} headers={headers} actions={actions}/>
            )}
            {!isTable && (
                <SensorGrid sensors={Object.values(sensors)}/>
            )}
        </div>
    );
}